import { match } from '@/utils/pattern-match-util'
import type { TaxRefundDeliveryMethodType } from './TaxRefundDeliveryMethod'

export function formatTaxDeliveryMethodType(
  type: TaxRefundDeliveryMethodType,
): string {
  return match(type, {
    Check: 'Paper check',
    FutureTaxCredit: 'Future tax credit',
    DirectDeposit: 'Direct deposit',
  })
}
